module.exports = "/_next/static/images/c87ca4706ba3ef4169b271ae1e2a52fb-aboutus-ed-desktop.jpg";